import React from 'react';

const PERSONALIZE = [
  'Company logos', 'Custom artwork', 'Client names', 'Property / address details',
  'Event branding', 'Wedding designs', 'Thank-you messages', 'Seasonal designs', 'Personalized messages',
];

const CorpLabelShowcase = () => (
  <section className="ff-section ff-section-alt" data-testid="corp-labels-copy">
    <div className="ff-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 40, alignItems: 'center' }}>
      <div>
        <p className="ff-eyebrow" style={{ color: 'var(--ff-gold)' }}>YOUR BRAND · ON THE BOTTLE</p>
        <h2>Turn a Bottle of Wine Into a Touchpoint for Your Brand.</h2>
        <p className="ff-lede">
          Not another gift card. Not another liquor-store bottle. Wine made for
          <em> this</em> client, <em>this</em> occasion, <em>this</em> team — with
          a label designed around your business, event or story.
        </p>
        <p style={{ margin: '12px 0 0', fontWeight: 600, color: 'var(--ff-burgundy)' }}>
          Choose your wine. Create your label. Make it yours.
        </p>
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
        {PERSONALIZE.map((p) => (
          <li key={p} style={{
            padding: '12px 14px', background: '#fff', borderRadius: 8, fontSize: 14,
            color: 'var(--ff-brown)', border: '1px solid rgba(74,46,30,0.1)',
          }}>{p}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default CorpLabelShowcase;
